import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import AdmissionApplicationForm from "../../components/AdmissionApplicationForm";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const ContactPage = () => {
  const location = useLocation();
  const { school_slug } = useParams();

  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);
  const [timings, setTimings] = useState([]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios.get(
      `${baseAPIUrl}api/general_settings/get_general_settings/${finalSchoolSlug}`
    )
      .then(res => {
        if (res.data.status === 1) {
          setInfo(res.data.data.settings);
          setTimings(res.data.data.timings || []);
        }
      })
      .catch(err => console.error("CONTACT API ERROR:", err))
      .finally(() => setLoading(false));
  }, [school_slug]);

  return (
    <div className="contact-page">
      <SchoolInnerPageBanner/>

      {/* CONTACT FORM SECTION */}
      <section id="contact-us" style={{ padding: '80px 20px', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="row">
            {/* Application Form Section */}
            <div className="col-md-12">
              {/* Application Form Section */}
              <AdmissionApplicationForm/>
            </div>
          </div>
          <div className="row mt-5">
            {/* FORM LEFT SIDE */}
            <div className="col-md-8">
              {/* GOOGLE MAP SECTION */}
              {info?.map_url && (
                <iframe
                  src={info.map_url}
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  loading="lazy"
                ></iframe>
              )}
            </div>

            {/* CONTACT INFO RIGHT SIDE */}
            <div className="col-md-4">
              <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px' }}>
                <h3 style={{ color: 'rgb(100, 19, 32)', marginBottom: '20px', fontFamily: 'Lora', fontSize: '1.8rem' }}>
                  Contact Information
                </h3>

                <div style={{ marginBottom: '20px' }}>
                  <h5 style={{ color: 'rgb(100, 19, 32)', fontFamily: 'Lora', fontSize: '1.4rem' }}>Head Office</h5>
                  <p>
                    {info?.address}
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h5 style={{ color: 'rgb(100, 19, 32)', fontFamily: 'Lora', fontSize: '1.4rem' }}>Phone</h5>
                  <p>{info?.phone}</p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h5 style={{ color: 'rgb(100, 19, 32)', fontFamily: 'Lora', fontSize: '1.4rem' }}>Email</h5>
                  <p>{info?.email}</p>
                </div>

                <div>
                  <h5 style={{ color: 'rgb(100, 19, 32)', fontFamily: 'Lora', fontSize: '1.4rem' }}>Office Hours</h5>
                  {timings.map((t, i) => (
                    <p>
                      <strong>{t.day_label}</strong>: {t.time_label}
                    </p>
                  ))}
                </div>
              </div>
            </div>



          </div>
        </div>
      </section>

    </div>
  );
};

export default ContactPage;
